import userBase from './user-base.vue'

export default userBase
